import { HttpErrorResponse } from '@angular/common/http';
import { isDefined } from '@mkp/shared/util-guards';
import { catchError, EMPTY, of, OperatorFunction } from 'rxjs';

export function catchHttpErrorFactory(status: number) {
  return <S, T>(callback: () => T | undefined): OperatorFunction<S, S | Exclude<T, void>> =>
    catchError((error: HttpErrorResponse) => {
      if (error.status !== status) {
        throw error;
      }

      const result = callback();
      return isDefined(result) ? of(result) : EMPTY;
    });
}
